/**
 * @file BulkBillsProgress.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-12
 * @modified 2026-10-12
 * @description Bulk Add Bills (2026-10-12): the progress tracker across the
 *              top of the whole workflow — "7 bills · 3 saved · 1 skipped · 3
 *              to do" over a bar (saved, skipped, to do), with how many are
 *              still being read. The counts are the server's
 *              (utils/bulkBillRules.progress).
 */

import React from 'react';
import './BulkAddBills.css';
import { progressText } from '../utils/bulkBillPlan';

function BulkBillsProgress({ progress, extra = null }) {
  const p = progress || { count: 0, saved: 0, replaced: 0, skipped: 0, todo: 0, reading: 0 };
  const count = p.count || 0;
  const pct = (n) => (count ? `${(n / count) * 100}%` : '0%');
  const saved = (p.saved || 0) + (p.replaced || 0);
  return (
    <div className="bulk-bills-progress" role="status" aria-live="polite">
      <div className="bulk-bills-progress-text">
        <span className="material-symbols-rounded">task_alt</span>
        <strong>{progressText(p)}</strong>
        {p.reading > 0 && <span className="bulk-bills-progress-reading">{p.reading} still being read…</span>}
        {extra && <span className="bulk-bills-progress-extra">{extra}</span>}
      </div>
      <div className="bulk-bills-progress-bar" aria-hidden="true">
        <span className="seg saved" style={{ width: pct(saved) }} title={`${saved} saved`} />
        <span className="seg skipped" style={{ width: pct(p.skipped || 0) }} title={`${p.skipped || 0} skipped`} />
      </div>
    </div>
  );
}

export default BulkBillsProgress;
